<template>
  <div id="partner">
    <menu-default/>
      <div class="jumbotron jumbotron-fluid">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h1 class="title text-center"><i class="fa fa-file-o"></i> Lista de todas as publicações</h1>
            </div>
          </div>
        </div>
      </div>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <table v-show="!loading" class="table table-bordered table-bordered" style="background: white">

            <thead class="thead-dark">
            <tr>
              <th scope="col">Publicação</th>
              <th width="80" scope="col">Revisão</th>
              <th class="text-center" scope="col" width="50">download</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="publication in publications" :key="publication">
              <td>{{ publication.name }} </td>
              <td>v. {{ publication.version }} </td>
              <td><a target="_blank" :href="'http://200.150.202.174/media/' + publication.file">Download</a> </td>
            </tr>
            <tr v-show="!publications.length"><td colspan="5" class="text-center">Nenhum resultado pode ser encontrado</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


    <footer-default/>
  </div>
</template>

<script>
  import publication from "../api/publication"
  import menuDefault from "./common/menu-default";
  import footerDefault from "./common/footer-default";
  import mixins from "../helpers/mixins"
  export default {
    name: "Partner",
    mixins: [mixins],
    data () {
      return {
        publications: [],
        loading: true
      }
    },
    components: { menuDefault, footerDefault },
    methods: {
      getPublications(){
        publication.partner().then((response)  =>  {
          this.publications = response.data
          this.loading = false
        })
      }
    },
    mounted(){
      this.getPublications()
    }
  }
</script>

<style scoped>

</style>
